import z from 'zod';
import { BILLING_TYPE_SCHEMA } from './billing-types.ts';
import { ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA } from './role.ts';

export const PaymentSettingSchema = z.object({
    billingMethod: BILLING_TYPE_SCHEMA,
    paymentTermId: z.number().nullable(),
    billingInterval: z.string().nullable(),
});

export const PaymentSettingsResponseSchema = z.object({
    transactionalRole: ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA,
    billingText: z.string().nullable(),
    selected: PaymentSettingSchema,
});

export const PaymentSettingsWithOptionsResponseSchema = z.object({
    transactionalRole: ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA,
    selected: PaymentSettingSchema.omit({ billingInterval: true }),
    billingText: z.string().nullable(),
    options: PaymentSettingSchema.omit({ billingInterval: true }).array(),
});

export const PaymentSettingsWithOptionsWithBillingIntervalResponseSchema = z.object({
    transactionalRole: ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA,
    billingText: z.string().nullable(),
    selected: PaymentSettingSchema,
    options: PaymentSettingSchema.array(),
});

export const PaymentSettingsWithTransactionalRoleResponseSchema = z.object({
    transactionalRole: ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA,
    ...PaymentSettingSchema.shape,
});
